import { InputLabel } from '@mui/material';
import { BrandKey, brandTitleByKey } from '@prismamedia/one-brandkey';
import {
  AutoSuggestField,
  InputGroup,
  SelectInput,
  TextInput,
  useEditContext,
} from '@prismamedia/one-crud-react';
import { FC, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { paths } from 'routing';
import { getBranKeys } from '../../../../../apollo/queries/getBrandKeys.newsletter.graphql';
import { BasicContainer } from '../../../../../components/BasicContainer';
import { useStyles } from '../styles';

const CAMPAIGN_SECTIONS_OPTIONS = Array.from(Array(21).keys())
  .slice(1)
  .map((label) => ({
    value: label,
    label,
  }));
interface ContentFieldsProps {
  campaignSectionCount: string;
  onCampaignSectionCountChange: (value: string) => void;
}

export const ContentFields: FC<ContentFieldsProps> = ({
  campaignSectionCount,
  onCampaignSectionCountChange,
}) => {
  const match = useRouteMatch<{ id: string }>();
  const isCreate = match.path === `${paths.NEWSLETTER_NEW}/generalities`;
  const classes = useStyles();
  const context = useEditContext();
  const [linkUrl, setLinkUrl] = useState(context.item.linkUrl || '');

  return (
    <BasicContainer title={`Template ${context.item._id || ''}`}>
      <InputGroup>
        {context.item.isFromNlf ? (
          <TextInput
            field="brandKey"
            label="Marque*"
            textFieldProps={{ fullWidth: true, disabled: true }}
          />
        ) : (
          <>
            <InputLabel className={classes.label}>Marque *</InputLabel>
            <AutoSuggestField
              fetchSuggestions={getBranKeys}
              inputValue={
                context.item.brandKey
                  ? brandTitleByKey[context.item.brandKey as BrandKey]
                  : ''
              }
              suggestionStyle={classes.suggestionStyle}
              onSuggestionSelected={({ id }) => {
                // eslint-disable-next-line immutable/no-mutation
                context.item = {
                  ...context.item,
                  brandKey: id,
                };
              }}
              keepSelectedValue
            />
          </>
        )}
      </InputGroup>
      <InputGroup>
        <TextInput
          field="name"
          label="Nom"
          textFieldProps={{ fullWidth: true, required: true }}
        />
      </InputGroup>
      <InputGroup>
        {context.item.isFromNlf && (
          <TextInput
            field="nlfName"
            label="Nom NL Factory"
            textFieldProps={{ fullWidth: true, disabled: true }}
          />
        )}
      </InputGroup>
      <InputGroup>
        <TextInput
          field="linkUrl"
          label="Url de preview"
          onChange={(_, value) => {
            // eslint-disable-next-line immutable/no-mutation
            context.item.linkUrl = value;
            setLinkUrl(value);
          }}
          textFieldProps={{
            value: linkUrl,
            fullWidth: true,
            disabled: context.item.isFromNlf,
          }}
        />
      </InputGroup>
      <InputGroup>
        <TextInput
          field="campaignPreHeaderPattern"
          label="Génération automatique du pré-header"
          textFieldProps={{ fullWidth: true }}
        />
      </InputGroup>
      <InputGroup>
        <TextInput
          field="campaignSubjectPattern"
          label="Génération automatique de l'objet"
          textFieldProps={{ fullWidth: true }}
        />
      </InputGroup>
      <InputGroup>
        <SelectInput
          field="defaultCampaignSectionCount"
          label="Nombre de section(s)"
          options={CAMPAIGN_SECTIONS_OPTIONS}
          onChange={
            ((_: string, value: string) => {
              // eslint-disable-next-line immutable/no-mutation
              context.item.defaultCampaignSectionCount = value;
              onCampaignSectionCountChange(value);
            }) as any
          }
          selectProps={{
            value: campaignSectionCount,
            fullWidth: true,
            disabled: isCreate ? false : context.item.sections !== null,
          }}
        />
      </InputGroup>
    </BasicContainer>
  );
};
